import PropTypes from "prop-types";
import React, { useRef, useEffect } from "react";
import CreateAccountForm from "../../sections/create-account-form";
import HeroAccount from "../../sections/hero-account";
import InfoPanel from "../../sections/info-panel";
import VerifyEmailForm from "../../sections/verify-email-form";
import useQuery from "../../utils/useQuery";
import { useHistory } from "react-router-dom";
import { codeTypes } from "../../utils/lynkco-constants";
import useCreateAccount from "../../hooks/useCreateAccount";
import { isLoggedIn } from "../../services/siteService";
import "./style.scss";

const CreateAccount = ({ lang, rendering, fields }) => {
  const { createAccountForm, backToLogin, heroAccountStep1, heroAccountStep2, infoPanelStep1, infoPanelStep2, verifyEmailForm, loginSuccessRedirectUrl } = fields;
  createAccountForm.fields.newsletter = !createAccountForm.fields.newsletter ? { id: null } : createAccountForm.fields.newsletter;
  const {
    newsletter: { id: newsletterConsentNo },
    termsAndConditions,
    createAccountFailedMessage,
    loginNetworkErrorMessage,
    registrationInProcessMessage
  } = createAccountForm.fields;

  useEffect(() => {
    if (isLoggedIn()) {
      history.replace(loginSuccessRedirectUrl.value.href);
    }
  }, []);

  const termsContents = termsAndConditions.map(x => x.id);
  const { formData, submitting, isNetworkFailed, accountExists, phoneExists, sendCodeFailed, createAccountFailed, isVerificationStep, registrationInProcess, verificationFailed, submitAccountInfo, onVerification } = useCreateAccount();
  const query = useQuery();
  const history = useHistory();
  const componentRef = useRef(null);
  const createAccountFormProps = {
    lang,
    ...createAccountForm.fields,
    createAccountFailed,
    isNetworkFailed,
    accountExists,
    phoneExists,
    registrationInProcess,
    backToLogin,
    submitting,
    preFilledData: formData,
    submitCreateAccount: async (evt, data) => {
      await submitAccountInfo(evt, data);
    }
  };
  const verifyEmailFormProps = {
    ...verifyEmailForm.fields,
    sendCodeFailed,
    verificationFailed,
    createAccountFailed,
    isNetworkFailed,
    registrationInProcess,
    createAccountFailedMessage,
    loginNetworkErrorMessage,
    registrationInProcessMessage,
    submittedEmail: formData?.email,
    codeType: codeTypes.activeAccount,
    lang,
    async onVerificationCodeSubmitted(evt, data) {
      const { userInfo, token } = await onVerification(data, termsContents, newsletterConsentNo);
      if (userInfo) {
        /** Measurement */
        let dataLayer = window.dataLayer || [];
        let membershipLevel = "Level0";

        switch (userInfo.membershipCode) {
          case "MEMBERSHIP01":
            membershipLevel = "Level0";
            break;
          case "MEMBERSHIP02":
            membershipLevel = "Level1";
            break;
          case "MEMBERSHIP03":
            membershipLevel = "Level2";
            break;
          case "MEMBERSHIP04":
            membershipLevel = "Level3";
            break;
        }
        dataLayer.push({
          event: "accountVerification",
          eventCategory: "account",
          eventAction: "verify",
          eventLabel: membershipLevel
        });
        if (query.redirect) {
          if (query.redirect.startsWith("https://") || query.redirect.startsWith("http://")) {
            global.location.href = `${query.redirect}?token=${token.accessToken}`;
          } else {
            history.replace(query.redirect);
          }
        } else if (loginSuccessRedirectUrl.value) {
          global.location.href = loginSuccessRedirectUrl.value.href;
        }
      }
    }
  };

  if (!createAccountForm.fields.newsletter.id) return <span className="warning-message">Create Account Form &gt; Newsletter Consent not set!</span>;
  if (!createAccountForm.fields.termsAndConditions.length) return <span className="warning-message">Create Account Form &gt; Terms and Conditions not set!</span>;
  return (
    <div className="create-account" datasourceid={rendering.dataSource} ref={componentRef}>
      {!isVerificationStep && (
        <div className={"grid"}>
          <HeroAccount {...heroAccountStep1.fields} id="collect-info" />
          <CreateAccountForm {...createAccountFormProps} />
          {infoPanelStep1 && <InfoPanel {...infoPanelStep1.fields} />}
        </div>
      )}
      {isVerificationStep && (
        <div className={"grid"}>
          <HeroAccount {...heroAccountStep2.fields} id="verify" />
          <VerifyEmailForm {...verifyEmailFormProps} />
          {infoPanelStep2 && <InfoPanel {...infoPanelStep2.fields} />}
        </div>
      )}
    </div>
  );
};

export default CreateAccount;

CreateAccount.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    createAccountForm: PropTypes.object,
    heroAccountStep1: PropTypes.object,
    heroAccountStep2: PropTypes.object,
    infoPanelStep1: PropTypes.object,
    infoPanelStep2: PropTypes.object,
    verifyEmailForm: PropTypes.object
  })
};

CreateAccount.defaultProps = {
  fields: {
    isVerificationStep: false
  }
};
